import { DefaultValueConfig, Locale } from '@headless-workspace/config';
import { mapImage, DataLayerClassName } from '@headless-workspace/domain/common/client';
import { PropsWithDataLayer } from '@headless-workspace/glow-ds';
import { Image } from '@headless-workspace/typings';
import { ObjectHelpers, UrlHelpers } from '@headless-workspace/utils';
import { HomeBrandoramaDTO, HomeSlotBase, HomeSlotType, mapHomeSlotBase } from '../../../../../src';

type HomeBrandoramaTile = PropsWithDataLayer & {
    image: Image;
    href: string;
    brandName: string;
    id: string;
    name: string;
};
export type HomeBrandoramaValue = HomeSlotBase & {
    type: HomeSlotType.Brandorama;
    tiles: HomeBrandoramaTile[];
};

export const mapHomeBrandorama = (dto: HomeBrandoramaDTO): HomeBrandoramaValue => {
    return {
        ...mapHomeSlotBase(dto),
        type: HomeSlotType.Brandorama,
        tiles: dto.details.brands.map((brand) => ({
            image: mapImage(brand.image) ?? ObjectHelpers.createImageWithSrc(DefaultValueConfig.imagePlaceholder),
            href: UrlHelpers.getHrefPathname(brand.link ?? DefaultValueConfig.href),
            brandName: brand.title ?? '',
            id: brand.id ?? '',
            name: brand.name ?? '',
            dataLayer: {
                id: brand.id ?? '',
                className: DataLayerClassName.brandorama,
            },
        })),
    };
};
